export const cAProvinces = [
  { title: 'Alberta', value: 'AB' },
  { title: 'British Columbia', value: 'BC' },
  { title: 'Manitoba', value: 'MB' },
  { title: 'New Brunswick', value: 'NB' },
  { title: 'Newfoundland and Labrador', value: 'NL' },
  { title: 'Northwest Territories', value: 'NT' },
  { title: 'Nova Scotia', value: 'NS' },
  { title: 'Nunavut', value: 'NU' },
  { title: 'Ontario', value: 'ON' },
  { title: 'Prince Edward Island', value: 'PE' },
  { title: 'Quebec', value: 'QC' },
  { title: 'Saskatchewan', value: 'SK' },
  { title: 'Yukon', value: 'YT' },
];
